<template>
  <Grid
    class="label text-body-1"
    align-items="center"
    :class="labelStateClass"
    :style="{ height: 'var(--r-space-lg)' }"
  >
    <slot />
  </Grid>
</template>

<script>
export default {
  props: {
    hasFocus: Boolean,
    disable: Boolean
  },

  computed: {
    labelStateClass() {
      if (this.disable) return 'text-white-5'
      if (this.hasFocus) return 'text-secondary-2'
      return 'text-secondary-1'
    }
  }
}
</script>
